import axios from 'axios';
import api from "./api.js";
const API_URL =  "https://app-dc37e42a-38d5-480d-9a3d-1349ea33f548.cleverapps.io/api/auth";
const user = "/users";
export const usersService = {
    // Signup Request
    async signup(userData) {
        const response = await axios.post(`${API_URL}/signup`, userData);
        return response.data;
    },

    // Login Request
    async login(credentials) {
        const response = await axios.post(`${API_URL}/login`, credentials);
        return response.data;  
    },

    // Email Verification Request
    async verifyEmail(email, code) {
        const response = await axios.post(`${API_URL}/verify`, { email, code });
        return response.data;
    },
    async resendCode(email) {
        const res = await axios.post(`${API_URL}/resend-code`,{email});
        return res.data;
    },
    async updateProfile(username,password) {
        const res = await  api.put(`${user}/update-profile`,{username,password});
        return res.data;
    },
    async deleteAccount() {
        const res = await api.delete(`${user}/delete-account`);
        return res.data;
    }
};